module.exports = __webpack_public_path__ + "static/media/visas.00b470d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/visas.png
// module id = 377
// module chunks = 0